import { forwardRef, Ref, useEffect, useImperativeHandle, useState } from "react";
import { ExSwitch } from "../../../components/ExSwitch";
import { Col, Row } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import React from "react";
import { SlidersHorizontal } from "lucide-react";
import { Modal } from "../../../components/Modal";

interface Acesso {
    usucodigo?: number;
    gruid: number;
    caption: string;
    usugruacenome: string;
    usugruaceler?: number;
    usugruaceincluir?: number;
    usugruacealterar?: number;
    usugruaceexcluir?: number;
}

const InnerView = ({ gruposProjetados, getDados, gruposCadastrados, auth }: any) => {
    const [optimisticState, setOptimisticState] = useState<any>([...gruposProjetados])

    async function updateStatus(_body: Acesso) {
        let body = {
            gruid: _body.gruid,
            usucodigo: _body.usucodigo,
            usugruaceler: _body.usugruaceler,
            usugruaceincluir: _body.usugruaceincluir,
            usugruacealterar: _body.usugruacealterar,
            usugruaceexcluir: _body.usugruaceexcluir,
            usugruacenome: _body.usugruacenome,
        }

        //(state: any[], action) => [
        const aux = optimisticState.map((e: any) => e.gruid === body.gruid && e.usucodigo === body.usucodigo ? { ...e, ...body, sending: true } : { ...e })
        //]

        setOptimisticState(aux)
        //addOptimistic(body)

        try {
            auth.post('/v1/usuariogrupoacesso', body).then(() => {
                getDados()
            });
        } catch (error) {
            console.log(error);
        }
    }

    const renderGrupoTree = (projetados: Acesso[]): React.JSX.Element[] => {
        return projetados
            .map(preGrupo => {
                const pGrupo = gruposCadastrados.find((e: any) => e.usugruacenome === preGrupo.usugruacenome);

                const grupo = pGrupo || preGrupo

                return (
                    <div key={grupo.usugruacenome} style={{ padding: '8px 0px' }}>
                        <Row style={{ opacity: pGrupo ? '100%' : '25%' }}>
                            <Col>
                                <div style={{ display: 'flex' }} >
                                    <span >{preGrupo.caption}</span>
                                </div>
                            </Col>
                            <Col><ExSwitch checked={grupo.usugruaceler === 1 && grupo.usugruacealterar === 1 && grupo.usugruaceexcluir === 1 && grupo.usugruaceexcluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruaceler: e.target.checked ? 1 : 0, usugruaceincluir: e.target.checked ? 1 : 0, usugruacealterar: e.target.checked ? 1 : 0, usugruaceexcluir: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruaceler === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruaceler: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruaceincluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruaceincluir: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruacealterar === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruacealterar: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruaceexcluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruaceexcluir: e.target.checked ? 1 : 0 })} /></Col>
                        </Row>
                    </div>
                );
            });
    };

    return (
        <div>
            {renderGrupoTree(optimisticState)}
        </div>
    )
}

interface AcessoProps {
    onRefresh: () => void
}

export interface AcessosHandler {
    openModal: (data: any) => void
}

const Acessos = forwardRef((props: AcessoProps, ref: Ref<AcessosHandler>) => {
    const [gruposCadastrados, setGruposCadastrados] = useState<Acesso[]>([]);
    const [gruposProjetados, setGruposProjetados] = useState<Acesso[]>([]);
    const [show, setShow] = useState(false);
    const [usucodigo, setUsucodigo] = useState();

    const auth = useAuth();

    useImperativeHandle(ref, () => ({
        openModal
    }))

    useEffect(() => {
        if (show)
            getDados();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    async function getDados() {
        try {
            // const responseProjetados: any = await auth.get('/v1/usuariogrupoacesso');
            const filteredProjetados = [
                { usugruacenome: 'CulturaCategoria', caption: 'Categoria', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Veiculo', caption: 'Veículo', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'CulturaTamanho', caption: 'Tamanho', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Produto', caption: 'Produto', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Cliente', caption: 'Cliente', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Plantio', caption: 'Plantio', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'ContasReceber', caption: 'Contas a Receber', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'MotivoRequisicao', caption: 'Motivo da Requisição', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Fornecedor', caption: 'Fornecedor', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Imobilizado', caption: 'Imobilizado', gruid: auth.grupo.gruid, usucodigo },
                { usugruacenome: 'Transportadora', caption: 'Transportadora', gruid: auth.grupo.gruid, usucodigo }
            ]  //responseProjetados.data.filter((item: any) => item.usucodigo === usucodigo);

            const responseCadastrados: any = await auth.get('/v1/usuariogrupoacesso');
            const filteredCadastrados = responseCadastrados.data.filter((item: any) => item.usucodigo === usucodigo);

            setGruposProjetados([...filteredProjetados]);
            setGruposCadastrados([...filteredCadastrados]);
        } catch (error) {
            console.log(error);
        }
    }

    // const initializeExpandedNodes = (): Set<number> => {
    //     return new Set(gruposProjetados.map(grupo => grupo.gruid));
    // };

    function openModal(_data: any) {
        setUsucodigo(_data.usucodigo);
        setShow(true);
    }

    function closeModal() {
        if (props.onRefresh)
            props.onRefresh();

        setShow(false);
    }

    return (
        <Modal
            show={show}
            onHide={closeModal}
            cancel={() => setShow(false)}
            size="xl"
            centered={true}
            title='Configuração de Acessos'
            icon={<SlidersHorizontal />}
        >
            <div style={{ padding: '5px 0' }}>
                <Row style={{ fontWeight: 'bold', padding: '8px 0' }}>
                    <Col>Grupo</Col>
                    <Col>Todos</Col>
                    <Col>Ler</Col>
                    <Col>Incluir</Col>
                    <Col>Alterar</Col>
                    <Col>Excluir</Col>
                </Row>
                {gruposProjetados.length && <InnerView gruposProjetados={gruposProjetados} getDados={getDados} gruposCadastrados={gruposCadastrados} auth={auth} />}
            </div>
        </Modal>
    );
});

export default Acessos
